import * as styles from './AppContainer.module.css'

import React from 'react'
import { Link } from 'gatsby'

interface Props {
  children: React.ReactNode
  title: React.ReactNode
  actions?: React.ReactNode
}

export const AppContainer: React.FC<Props> = (props) => {
  const { children, title, actions } = props

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>{title}</h1>

        {actions && <div>{actions}</div>}
      </div>

      {children}

      <footer className={styles.footer}>
        &copy; 2026 <Link to="/">Lucky Paper</Link>. Card images and data
        courtesy of <a href="https://scryfall.com/">Scryfall</a>.
      </footer>
    </div>
  )
}
